import { useCatalog } from "../hooks/useCatalog";
import { ProductCard } from "../components/ProductCard";
import { ServiceCard } from "../components/ServiceCard";
import { SectionHeader } from "../components/SectionHeader";

export function ShopPage() {
  const { menu, services } = useCatalog();

  return (
    <main className="page-shell">
      <SectionHeader eyebrow="Order, deposits, and experiences" title="Shop OJ's Bistro" centered level={1} />
      <div className="catalog-grid">
        {menu.slice(0, 6).map((item) => (
          <ProductCard key={item.id} item={item} />
        ))}
      </div>
      <SectionHeader title="Experience Deposits" centered />
      <div className="service-grid">
        {services.map((service) => (
          <ServiceCard key={service.id} service={service} />
        ))}
      </div>
    </main>
  );
}
